import Login from '@/views/auth/Login';
import VerifyEmail from '@/views/auth/VerifyEmail';
import ForgotPassword from '@/views/auth/ForgotPassword';
import SignUp from '@/views/auth/SignUp';

export default [
  {
    path: '/verify-email',
    name: 'verify-email',
    component: VerifyEmail,
    meta: { requiresAuth: true, acceptsUnverified: true },
  },
  {
    path: '/forgot-password',
    name: 'forgot-password',
    component: ForgotPassword,
    meta: { requiresNonAuth: true },
  },
  {
    path: '/login',
    name: 'login',
    component: Login,
    meta: { requiresNonAuth: true },
  },
  {
    path: '/sign-up/:type',
    name: 'sign-up',
    component: SignUp,
    meta: { requiresNonAuth: true },

  },
];
